import React, { useState, useEffect, ComponentType } from 'react';
import { showLoader, showToast, ToastVariants, ClaimAccessForm } from '../index';
import { constants } from '../../constants';
import storage from '../../services/localStorage.service';

interface ContainerProps {
    history: any;
    match: any;
    setLoading: (status: boolean) => void;
}

const styleLoader = (Container: ComponentType<any>, query: (params: any) => Promise<any>) => {
    return function ContainerHOC(props: ContainerProps) {
        const [response, setResponse] = useState({});
        const [isUnauthorized, setIsUnauthorized] = useState(false);

        const fetchData = (params: any) => {
            showLoader(query(params)).then((res: any) => {
                if (!res || (res.status && res.status !== 206)) {
                    showToast({
                        title: 'Failed!',
                        content: 'Something went wrong. Please try again later.',
                        variant: ToastVariants.DANGER,
                    });
                    props.history.push('/');
                    return;
                }
                if (res.status === 206) {
                    // ClaimAccessForm needs both carddetid and clientcardsrno
                    // to mint a session token.  On routes that lack them
                    // (order-detail, faq, etc.) we cannot recover, so fall
                    // through to the same generic failure path as any other
                    // unrecoverable error instead of silently rendering an
                    // empty container.
                    const { params } = props.match;
                    if (!params.carddetid || !params.clientcardsrno) {
                        showToast({
                            title: 'Unauthorized',
                            content: 'Something went wrong. Please try again later.',
                            variant: ToastVariants.DANGER,
                        });
                        props.history.push('/');
                        return;
                    }
                    setIsUnauthorized(true);
                    props.setLoading(false);
                    return;
                }
                if (res.status === 0) {
                    setIsUnauthorized(false);
                    if (res.customstyle) {
                        var { API_STYLES_PATH } = constants;
                        var head = document.getElementsByTagName('head')[0];
                        var link = document.createElement('link');
                        link.id = 'retailer';
                        link.rel = 'stylesheet';
                        link.type = 'text/css';
                        link.href = API_STYLES_PATH + res.customstyle;
                        link.media = 'all';
                        head.appendChild(link);
                        storage.setCustomStyle(res.customstyle);
                    }
                    if (res.group) {
                        storage.setGroupLogo(res.group.grouplogo);
                    }
                    setResponse(res);
                    props.setLoading(false);
                }
            });
        };

        useEffect(() => {
            const { params } = props.match;
            fetchData(params);
        }, []);

        if (isUnauthorized) {
            const { params } = props.match;
            return (
                <ClaimAccessForm
                    carddetid={parseInt(params.carddetid)}
                    clientcardsrno={params.clientcardsrno}
                    onSuccess={() => fetchData(params)}
                />
            );
        }

        return <Container {...props} response={response} />;
    };
};

export default styleLoader;
